import React from 'react';
import { useNavigate } from 'react-router-dom';
import CommonAuthComponent from './CommonAuthComponent';

const ConfirmedNewLinkSent = () => {
  const navigate = useNavigate();
  
  const handleOkay = () => {
    navigate('/login');
  };
  
  return (
    <CommonAuthComponent maxWidthClass="max-w-md">
      <div className="flex flex-col items-center space-y-3">
        {/* Heading */}
        <h1 className="text-[22px] text-center mb-[10px] font-medium leading-[30px]">
          Confirmed New Link Sent
        </h1>
        
        {/* Body */}
        <p className="text-center text-[16px] mb-[26px] font-normal leading-[22px]">
          We've sent a new password reset link to your email. Please check your inbox
          (and spam folder if needed)
        </p>
        
        {/* Security note (testing override to 1 minute) */}
        <p className="text-[12px] text-teal-300 mx-auto leading-[20px]">
          For security, password reset link expires after 15 minute
        </p>
        
        {/* CTA */}
        <button
          onClick={handleOkay}
          className="w-full inline-flex disabled:opacity-50 rounded-[4px] border transition-all duration-300 text-body-lg items-center font-semibold justify-center px-6 py-3.5
            bg-REELTeal border border-transparent hover:bg-teal-200 text-white mt-[20px]"
        >
          Okay
        </button>
      </div>
    </CommonAuthComponent>
  );
};

export default ConfirmedNewLinkSent;